import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import SectionHeader from "../../SectionHeader/SectionHeader"
import HomeMap from "./HomeMap"
import HomeContactInfo from "./HomeContactInfo"
import HomePageContactform from "./HomePageContactform"
import useFacilityData from "../../../hooks/useFacilityData.ts"

const HomeContactStyles = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 130px;
  /* padding-top: 25px;
  margin-top: -25px; */
`

const SubHeader = styled.h3`
  font-size: 25px;
  font-weight: 400;
  color: black;
  margin: -10px 0 40px;
`

const HomeContactMapInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  margin-bottom: 87px;
  @media screen and (min-width: 1500px) {
    flex-direction: row;
  }
`

const HomeContact = () => {
  const pageData = useFacilityData()

  const info = pageData.sanityFacility.facilityObj

  return (
    <HomeContactStyles id="HomePage-contact" role="region">
      <SectionHeader>Contact</SectionHeader>
      <SubHeader>
        Contact us today to set up a tour for you and your family.
      </SubHeader>
      <HomeContactMapInfo>
        <HomeMap
          mapCode={info.siteContent.googleMapsEmbed.googleMapsEmbedCode}
        />
        <HomeContactInfo info={info.facilityInfo} />
      </HomeContactMapInfo>
      <HomePageContactform facilityEmail={info.facilityInfo.email} />
    </HomeContactStyles>
  )
}

export default HomeContact
